import React, { useState, useRef, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { cleanHtml } from 'utils/utils';

const SeeMoreHtmlContent = ({ html }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const contentRef = useRef(null);
  const {t} = useTranslation() 

  // Sanitize the HTML content
  const sanitizedHtml = DOMPurify.sanitize((html === "null" || !html) ? "" : html);
  const cleaned = cleanHtml(sanitizedHtml);
  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    const checkClamp = () => {
      const content = contentRef.current;
      if (content) {  
        setIsClamped(content.scrollHeight > content.clientHeight);
      }
    };
    setIsExpanded(false);
    setTimeout(checkClamp, 10);

    window.addEventListener('resize', checkClamp);
    return () => {
      window.removeEventListener('resize', checkClamp);
    };
  }, [html]);

  return (
    <div className='html-wrapper mt-0 2sm:mt-1.5'>
      <div
        ref={contentRef}
        className={`html-content text-[13px] 2sm:text-sm 3md:text-base leading-5 break-words 2sm:leading:5 ${isExpanded ? 'expanded' : 'collapsed'}`}
        dangerouslySetInnerHTML={{ __html: cleaned }}
      />
      {isClamped && (
        <button onClick={toggleExpand} className='text-[13px] 2sm:text-sm 3md:text-base'>
          {isExpanded ? t('See Less') : t('See More')}
        </button>
      )}
    </div>
  );
};

export default SeeMoreHtmlContent;
